import ReferenceDataProvider from './ReferenceDataContext';
import ReferenceData from './ReferenceData';


let Index = () => {
    return (
        <ReferenceDataProvider>
            <ReferenceData />
        </ReferenceDataProvider>
    )
}

export default Index;